import formatEventDates from "./KEventDate";

const getApiBase = () => {
  const envUrl =
    process.env.REACT_APP_PUBLIC_API_BASE_URL ||
    process.env.REACT_APP_KAY_API_BASE_URL;

  return (envUrl || "https://backend-api.konn3ct.ng").replace(/\/+$/, "");
};

const buildApiUrl = (endpoint) => {
  const base = getApiBase();
  const cleanEndpoint = endpoint.startsWith("/") ? endpoint : `/${endpoint}`;
  const apiPath = cleanEndpoint.startsWith("/api/") ? cleanEndpoint : `/api${cleanEndpoint}`;
  return base ? `${base}${apiPath}` : apiPath;
};

const getImageBase = () => {
  const envUrl = process.env.REACT_APP_PREREG_IMAGE_BASE_URL;
  if (envUrl) {
    return envUrl.replace(/\/+$/, "");
  }
  const apiBase = getApiBase();
  return apiBase ? `${apiBase}/prereg` : "https://backend-api.konn3ct.ng/prereg";
};

const DEFAULT_IMAGE =
  "https://ui-avatars.com/api/?name=Event&background=10B981&color=fff";

const readJson = async (response) => {
  try {
    return await response.json();
  } catch {
    return null;
  }
};

export const formatEventFromAPI = (apiEvent) => {
  const timezoneLabel = apiEvent.timezone || "Africa/Lagos";
  const rawDate = `${apiEvent.date || ""} | ${apiEvent.time || ""}`.trim();
  const { dateString, fullDate } = formatEventDates(
    rawDate,
    timezoneLabel
  );

  const imageBase = getImageBase();
  const logoUrl = apiEvent.logo
    ? `${imageBase}/${String(apiEvent.logo).replace(/^\/+/, "")}`
    : DEFAULT_IMAGE;

  return {
    eventId: apiEvent.id ?? apiEvent.event_id ?? null,
    ref: apiEvent.ref ?? apiEvent.reference ?? null,
    title: apiEvent.title || "Untitled Event",
    organizer: apiEvent.host_name || apiEvent.organizer || "Konn3ct",
    location: apiEvent.location || "Konn3ct Room",
    timezone: timezoneLabel,
    date: rawDate,
    dateString,
    fullDate,
    description: apiEvent.about || "No description available.",
    image: logoUrl,
    logo: logoUrl,
    banner: logoUrl,
    tag: Number(apiEvent.public) === 1 ? "Public" : "Event",
    free: apiEvent.free !== undefined && apiEvent.free !== null ? Number(apiEvent.free) : 1,
    amount: apiEvent.amount || "0",
    currency: apiEvent.currency
      ? String(apiEvent.currency).toUpperCase()
      : null,
    country: apiEvent.country || null,
  };
};

const requestSearch = async ({ search = "", location = null, country = null } = {}) => {
  const formData = new FormData();
  if (search && search.trim()) {
    formData.append("search", search.trim());
  }

  if (location) {
    formData.append("location", location);
  }

  if (country) {
    formData.append("country", country);
  }

  const endpoint = buildApiUrl("/pre-registration-search");

  console.log("[EventsApi] 🚀 Fetching events from:", endpoint, { search, location, country });

  const response = await fetch(endpoint, {
    method: "POST",
    body: formData,
  });

  const body = await readJson(response);
  console.log("[EventsApi] 📥 Search Response:", response.status, body);

  if (!response.ok || !body?.success) {
    throw new Error(
      body?.message || `Unable to load events (HTTP ${response.status}).`
    );
  }

  return (body.data || []).map(formatEventFromAPI);
};

export const fetchAllEvents = async (country = null) => {
  return requestSearch({ country });
};

export const searchEvents = async (
  search = "",
  location = null,
  country = null
) => {
  return requestSearch({
    search,
    location,
    country,
  });
};

const enrichEventId = async (event, requestedRef, countryCode) => {
  if (event?.eventId) {
    return event;
  }

  const findExact = (events) =>
    events.find(
      (item) => String(item.ref || "") === String(requestedRef || ""),
    );

  try {
    const countryEvents = await requestSearch({
      country: countryCode || "GLOBAL",
    });
    const match = findExact(countryEvents);

    if (match?.eventId) {
      return {
        ...event,
        eventId: match.eventId,
        country: event.country || match.country,
      };
    }

    if (countryCode && String(countryCode).toUpperCase() !== "GLOBAL") {
      const globalEvents = await requestSearch({ country: "GLOBAL" });
      const globalMatch = findExact(globalEvents);

      if (globalMatch?.eventId) {
        return {
          ...event,
          eventId: globalMatch.eventId,
          country: event.country || globalMatch.country,
        };
      }
    }
  } catch (error) {
    console.warn("[EventsApi] Could not enrich event_id:", error);
  }

  return event;
};

export const fetchEventByRef = async (requestedRef, countryCode = "") => {
  if (!requestedRef) return null;

  const endpoint = buildApiUrl(`/pre-registration/${encodeURIComponent(requestedRef)}`);
  console.log("[EventsApi] 🚀 Fetching single event from:", endpoint);

  const response = await fetch(endpoint, {
    method: "GET",
    headers: {
      Accept: "application/json",
    },
  });

  if (response.status === 404) {
    return null;
  }

  const body = await response.json();
  console.log("[EventsApi] 📥 Single Event Response:", response.status, body);

  if (!response.ok) {
    throw new Error(
      body?.message || "Unable to load event."
    );
  }

  const apiEvent =
    body?.data?.preg?.[0] ||
    body?.data?.[0] ||
    body?.data ||
    null;

  if (!apiEvent) {
    return null;
  }

  const formatted = formatEventFromAPI(apiEvent);

  // return {
  //   ...formatted,
  //   ref: formatted.ref || requestedRef,
  // };

  const event = {
    ...formatted,
    ref: formatted.ref || requestedRef,
  };
    return enrichEventId(event, requestedRef, countryCode);

};



// import formatEventDates from "./KEventDate";

// const API_BASE =
//   (process.env.REACT_APP_KAY_API_BASE_URL ||
//     process.env.REACT_APP_PUBLIC_API_BASE_URL ||
//     "https://backend-api.konn3ct.ng")
//     .replace(/\/+$/, "");

// const buildApiUrl = (endpoint) => {
//   const cleanEndpoint = endpoint.startsWith("/") ? endpoint : `/${endpoint}`;
//   const apiPath = cleanEndpoint.startsWith("/api/")
//     ? cleanEndpoint
//     : `/api${cleanEndpoint}`;

//   return `${API_BASE}${apiPath}`;
// };

// const getImageBase = () => {
//   const envUrl = process.env.REACT_APP_PREREG_IMAGE_BASE_URL;

//   if (envUrl) {
//     return envUrl.replace(/\/+$/, "");
//   }

//   // Event images are served from the existing prereg media host.
//   return "https://backend-api.konn3ct.ng/prereg";
// };

// const DEFAULT_IMAGE =
//   "https://ui-avatars.com/api/?name=Event&background=10B981&color=fff";

// const readJson = async (response) => {
//   try {
//     return await response.json();
//   } catch {
//     return null;
//   }
// };

// export const formatEventFromAPI = (apiEvent = {}) => {
//   const timezoneLabel = apiEvent.timezone || "Africa/Lagos";
//   const rawDate = `${apiEvent.date || ""} | ${apiEvent.time || ""}`.trim();

//   const { dateString, fullDate } = formatEventDates(
//     rawDate,
//     timezoneLabel
//   );

//   const imageBase = getImageBase();

//   const logoUrl = apiEvent.logo
//     ? `${imageBase}/${String(apiEvent.logo).replace(/^\/+/, "")}`
//     : DEFAULT_IMAGE;

//   return {
//     eventId: apiEvent.id ?? apiEvent.event_id ?? null,
//     ref: apiEvent.ref ?? apiEvent.reference ?? null,
//     title: apiEvent.title || "Untitled Event",
//     organizer: apiEvent.host_name || apiEvent.organizer || "Konn3ct",
//     location: apiEvent.location || "Konn3ct Room",
//     timezone: timezoneLabel,
//     date: rawDate,
//     dateString,
//     fullDate,
//     description: apiEvent.about || "No description available.",
//     image: logoUrl,
//     logo: logoUrl,
//     banner: logoUrl,
//     tag: Number(apiEvent.public) === 1 ? "Public" : "Event",
//     free:
//       apiEvent.free !== undefined && apiEvent.free !== null
//         ? Number(apiEvent.free)
//         : 1,
//     amount: apiEvent.amount ?? "0",
//     currency: apiEvent.currency
//       ? String(apiEvent.currency).toUpperCase()
//       : null,
//     country: apiEvent.country || apiEvent.owner?.country || null,
//   };
// };

// const requestSearch = async ({
//   search = "",
//   location = null,
//   country = null,
// } = {}) => {
//   const endpoint = buildApiUrl("/pre-registration-search");

//   const payload = {
//     search: String(search || "").trim(),
//     country: country || "",
//     location: location || "",
//   };

//   let response;

//   try {
//     response = await fetch(endpoint, {
//       method: "POST",
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(payload),
//     });
//   } catch (networkError) {
//     const error = new Error(
//       "Could not reach the Konn3ct events API."
//     );
//     error.code = "NETWORK_ERROR";
//     error.cause = networkError;
//     throw error;
//   }

//   const body = await readJson(response);

//   if (!response.ok || body?.success !== true) {
//     throw new Error(
//       body?.message || `Unable to load events (HTTP ${response.status}).`
//     );
//   }

//   return (body.data || []).map(formatEventFromAPI);
// };

// export const fetchAllEvents = async (country = null) => {
//   return requestSearch({ country });
// };

// export const searchEvents = async (
//   search = "",
//   location = null,
//   country = null
// ) => {
//   return requestSearch({
//     search,
//     location,
//     country,
//   });
// };

// const resolveEventIdFromCatalogue = async (requestedRef) => {
//   const events = await requestSearch();

//   const exactMatch = events.find(
//     (item) =>
//       String(item.ref || "").trim() === String(requestedRef || "").trim()
//   );

//   return exactMatch?.eventId ?? null;
// };

// export const fetchEventByRef = async (requestedRef) => {
//   const cleanRef = String(requestedRef || "").trim();

//   if (!cleanRef) {
//     return null;
//   }

//   const endpoint = buildApiUrl(
//     `/pre-registration/${encodeURIComponent(cleanRef)}`
//   );

//   let response;

//   try {
//     response = await fetch(endpoint, {
//       method: "GET",
//       headers: {
//         Accept: "application/json",
//       },
//     });
//   } catch (networkError) {
//     const error = new Error(
//       "Could not reach the Konn3ct event-detail API."
//     );
//     error.code = "NETWORK_ERROR";
//     error.cause = networkError;
//     throw error;
//   }

//   if (response.status === 404) {
//     return null;
//   }

//   const body = await readJson(response);

//   if (!response.ok) {
//     throw new Error(
//       body?.message || `Unable to load event (HTTP ${response.status}).`
//     );
//   }

//   const apiEvent =
//     body?.data?.preg?.[0] ||
//     body?.data?.[0] ||
//     body?.data ||
//     null;

//   if (!apiEvent) {
//     return null;
//   }

//   const formatted = formatEventFromAPI(apiEvent);

//   let eventId = formatted.eventId;

//   /*
//     Kay's latest Postman example for GET /api/pre-registration/:reference
//     does not include id/event_id, while the public catalogue does.
//     For paid events, enrich the detail object with the authoritative prereg.id.
//   */
//   if (Number(formatted.free) === 0 && !eventId) {
//     eventId = await resolveEventIdFromCatalogue(cleanRef);
//   }

//   return {
//     ...formatted,
//     eventId,
//     ref: formatted.ref || cleanRef,
//   };
// };





// import formatEventDates from "./KEventDate";

// const isDev = process.env.NODE_ENV === "development";

// const getApiBase = () => {
//   const envUrl = process.env.REACT_APP_PUBLIC_API_BASE_URL;
//   if (envUrl) {
//     return envUrl.replace(/\/+$/, "");
//   }
//   // In local dev without explicit URL, use relative to route via Webpack proxy
//   return isDev ? "" : "https://backend-api.konn3ct.ng";
// };

// const buildApiUrl = (endpoint) => {
//   const base = getApiBase();
//   const cleanEndpoint = endpoint.startsWith("/") ? endpoint : `/${endpoint}`;
//   const apiPath = cleanEndpoint.startsWith("/api/") ? cleanEndpoint : `/api${cleanEndpoint}`;
//   return base ? `${base}${apiPath}` : apiPath;
// };

// const getImageBase = () => {
//   const envUrl = process.env.REACT_APP_PREREG_IMAGE_BASE_URL;
//   if (envUrl) {
//     return envUrl.replace(/\/+$/, "");
//   }
//   const apiBase = getApiBase();
//   return apiBase ? `${apiBase}/prereg` : "https://backend-api.konn3ct.ng/prereg";
// };

// const DEFAULT_IMAGE =
//   "https://ui-avatars.com/api/?name=Event&background=10B981&color=fff";

// const readJson = async (response) => {
//   try {
//     return await response.json();
//   } catch {
//     return null;
//   }
// };

// export const formatEventFromAPI = (apiEvent) => {
//   const timezoneLabel = apiEvent.timezone || "Africa/Lagos";
//   const rawDate = `${apiEvent.date || ""} | ${apiEvent.time || ""}`.trim();
//   const { dateString, fullDate } = formatEventDates(
//     rawDate,
//     timezoneLabel
//   );

//   const imageBase = getImageBase();
//   const logoUrl = apiEvent.logo
//     ? `${imageBase}/${String(apiEvent.logo).replace(/^\/+/, "")}`
//     : DEFAULT_IMAGE;

//   return {
//     eventId: apiEvent.id ?? apiEvent.event_id ?? null,
//     ref: apiEvent.ref ?? apiEvent.reference ?? null,
//     title: apiEvent.title || "Untitled Event",
//     organizer: apiEvent.host_name || apiEvent.organizer || "Konn3ct",
//     location: apiEvent.location || "Konn3ct Room",
//     timezone: timezoneLabel,
//     date: rawDate,
//     dateString,
//     fullDate,
//     description: apiEvent.about || "No description available.",
//     image: logoUrl,
//     logo: logoUrl,
//     banner: logoUrl,
//     tag: Number(apiEvent.public) === 1 ? "Public" : "Event",
//     free: apiEvent.free !== undefined && apiEvent.free !== null ? Number(apiEvent.free) : 1,
//     amount: apiEvent.amount || "0",
//     currency: apiEvent.currency
//       ? String(apiEvent.currency).toUpperCase()
//       : null,
//     country: apiEvent.country || null,
//   };
// };

// const requestSearch = async ({ search = "", location = null, country = null } = {}) => {
//   const formData = new FormData();
//   if (search && search.trim()) {
//     formData.append("search", search.trim());
//   }

//   if (location) {
//     formData.append("location", location);
//   }

//   if (country) {
//     formData.append("country", country);
//   }

//   const endpoint = buildApiUrl("/pre-registration-search");

//   console.log("[EventsApi] 🚀 Fetching events from:", endpoint, { search, location, country });

//   const response = await fetch(endpoint, {
//     method: "POST",
//     body: formData,
//   });

//   const body = await readJson(response);
//   console.log("[EventsApi] 📥 Search Response:", response.status, body);

//   if (!response.ok || !body?.success) {
//     throw new Error(
//       body?.message || `Unable to load events (HTTP ${response.status}).`
//     );
//   }

//   return (body.data || []).map(formatEventFromAPI);
// };

// export const fetchAllEvents = async (country = null) => {
//   return requestSearch({ country });
// };

// export const searchEvents = async (
//   search = "",
//   location = null,
//   country = null
// ) => {
//   return requestSearch({
//     search,
//     location,
//     country,
//   });
// };

// export const fetchEventByRef = async (requestedRef) => {
//   if (!requestedRef) return null;

//   const endpoint = buildApiUrl(`/pre-registration/${encodeURIComponent(requestedRef)}`);
//   console.log("[EventsApi] 🚀 Fetching single event from:", endpoint);

//   const response = await fetch(endpoint, {
//     method: "GET",
//     headers: {
//       Accept: "application/json",
//     },
//   });

//   if (response.status === 404) {
//     return null;
//   }

//   const body = await response.json();
//   console.log("[EventsApi] 📥 Single Event Response:", response.status, body);

//   if (!response.ok) {
//     throw new Error(
//       body?.message || "Unable to load event."
//     );
//   }

//   const apiEvent =
//     body?.data?.preg?.[0] ||
//     body?.data?.[0] ||
//     body?.data ||
//     null;

//   if (!apiEvent) {
//     return null;
//   }

//   const formatted = formatEventFromAPI(apiEvent);

//   return {
//     ...formatted,
//     ref: formatted.ref || requestedRef,
//   };
// };